<template lang="pug">
  div.r-operator-objects-table.body.body-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            div.search
              form(@submit.prevent.stop="startSearch()").search
                input(
                type="search"
                v-model="searchQ"
                placeholder=""
                )
            div.actions-panel
              e-button-edit(
              @click.stop.prevent="addNewRowToTable"
              )

      div
        e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        @deleteItem="deleteItem"
        ref="innerTable"
        )

      e-modal(v-if="showModal"
      @close="showModal = false"
      @confirm="saveList()"
      title="Редактирование списка Объектов обращения с отходами"
      )
        slot
          e-table-checked-list(
          @checkedChange="listUpdate($event)"
          :endpoint="endpointList"
          :earlyCheckedItems="earlyChecked"
          :showPaginate="true"
          )

        template(slot="footer")
          div.search-result
            span Выбрано {{checkedLen}} объектов
          div
            button(
            type="button"
            @click="closeModal()"
            ).actions-filter-panel__button.standart.standart-noborder Отмена
            button(
            type="button"
            @click="saveList()"
            ).actions-filter-panel__button.standart Сохранить


</template>

<script>
  import {tko} from '../../../api/api-endpoints.js'

  export default {
    name: 'r-operator-objects-table',
    props: {
      fields: Object
    },
    data () {
      return {
        searchQ: '',
        operationType: null,
        showModal: false,
        checkedLen: 0,
        checked: []
      }
    },
    computed: {
      visibleColumns () {
        return {
          name: {
            label: 'Наименование'
          },
          actions: {
            label: 'Назначение объекта'
          },
          is_intermunicipal: {
            label: 'Межмуниципальный'
          },
          status: {
            label: 'Статус объекта'
          },
          address: {
            label: 'Местоположение'
          },
          garbage_groups: {
            label: 'Группа обслуживаемых отходов'
          }
        }
      },
      selectListOptions () {
        return [
          {
            id: 'objects',
            name: 'Объекты обращения с отходами'
          }
        ]
      },
      earlyChecked () {
        return {default: this.fields.tkoObject}
      }
    },
    created () {
      this.formSubs = this.$emitter.listen('form', (evt) => this.onForm(evt))
    },
    destroyed () {
      this.formSubs.unsubscribe()
    },
    methods: {
      /**
       * @returns {Promise}
       */
      saveAllRows () {
        return Promise.resolve(1)
      },
      onForm ({action}) {
        if (action === 'onSaveForm') {
          this.updateDataInInnerTable()
        }
      },
      startSearch () {
        this.$refs.innerTable.updateTable()
      },
      updateDataInInnerTable () {
        // server slow update data??
        this.$bar.start()
        setTimeout(() => {
          // @fix: Cannot read property 'fetchData' of undefined
          if (this.$refs.innerTable) {
            this.$refs.innerTable.updateTable()
          }
        }, 700)
      },
      removeFromFields (item) {
        let fName = 'tkoObject'
        let filtered = (this.fields[fName] || []).filter(id => item[fName] && item[fName].indexOf(id) === -1)
        this.$set(this.fields, fName, filtered)
      },
      deleteItem (item) {
        if (this.fields.id) {
          this.$bar.start()
          const url = tko.operatorObjectDelete(this.fields.id, item.id)
          this.$store.dispatch('deleteModel', {
            url
          }).then(() => {
            this.$bar.finish()
            this.updateDataInInnerTable()
            this.removeFromFields(item)
          }).catch(e => {
            console.error(e)
            this.$e.errorBox(e)
            this.$bar.finish()
          })
        }
      },
      endpointListForInnerTable (ctx, query = {'per-page': 10}) {
        let route = {query}
        if (ctx.q) {
          route.query.q = ctx.q
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }
        if (this.searchQ) {
          route.query.q = this.searchQ
        } else {
          delete route.query.q
        }
        return {
          url: (this.fields.id ? tko.operatorObject(this.fields.id, route) : null),
          fields: {
            name: {
              label: 'Наименование'
            },
            actions: {
              label: 'Назначение объекта'
            },
            intermunicipal: {
              label: 'Межмуниципальный'
            },
            status: {
              label: 'Статус объекта'
            },
            address: {
              label: 'Местоположение'
            },
            garbage_groups: {
              label: 'Группа обслуживаемых отходов'
            }
          }
        }
      },
      endpointList (ctx, query = {'per-page': 50}) {
        let route = {query}
        if (ctx.q) {
          route.query.q = ctx.q
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }

        return {
          url: tko.objectSimple(route),
          fields: {
            name: {
              label: 'Наименование'
            },
            garbage_groups: {
              label: 'Группа обслуживаемых отходов'
            },
            status: {
              label: 'Статус объекта'
            },
            address: {
              label: 'Местоположение'
            }
          }
        }
      },
      listUpdate ($event) {
        let {checked, checkedLen} = $event
        this.checkedLen = checkedLen
        this.checked = checked
      },
      saveList () {
        let checkedValuesObj = JSON.parse(JSON.stringify(this.checked))
        this.$set(this.fields, 'tkoObject', checkedValuesObj.default)
        this.closeModal()
        this.$emit('saved')
      },
      closeModal () {
        this.showModal = false
        this.checkedLen = 0
      },
      openModal () {
        this.showModal = true
      },
      addNewRowToTable () {
        this.openModal()
      }
    }
  }
</script>
